import React from 'react';
import { Link } from 'gatsby';
import { IconButton, Toolbar } from '@material-ui/core/';
import HelpOutline from '@material-ui/icons/HelpOutline';
import classnames from 'classnames';
import { Logo } from '@icons/logo';
import { useContent } from '../../../content/content-provider';
import { TextButton } from '../Buttons';
import ArrowBackButton from '../ArrowBackButton';
import { useMenuScrollListener } from '../../../menus/providers/MenuScrollListenerProvider';
import {
  MainCategoriesBar,
  SubCategoriesNavigation,
} from '../../../menus/components/MenuNavigation';
import { MenuCategories } from '../../propTypes/builtMenuTypes';
import styles from './Header.styles';
import { LeaveTableButton } from '../LeaveTableButton';

interface HeaderProps {
  currentPage: string;
  displayLogo?: boolean;
  onClickViewBill?: () => void | undefined;
  onClickBackArrow?: () => void | undefined;
  displayFaq?: boolean;
  menuCategories?: MenuCategories;
  displayMenuNavigation?: boolean;
  displayLeaveTable?: boolean;
}

const Header = ({
  currentPage,
  onClickViewBill = undefined,
  onClickBackArrow = undefined,
  displayFaq = false,
  displayLogo = false,
  menuCategories,
  displayMenuNavigation = false,
  displayLeaveTable = false,
}: HeaderProps) => {
  const classes = styles();
  const [content] = useContent();
  const { selectedSubcategory } = useMenuScrollListener();

  const faqStyling = classnames({
    [classes.faqOnly]: displayFaq && !onClickViewBill && !onClickBackArrow && !displayLeaveTable,
  });

  const containerWithLogo = classnames({
    [classes.containerWithLogo]: displayLogo,
  });

  return (
    <>
      <Toolbar role="toolbar" className={`${classes.container} ${faqStyling} ${containerWithLogo}`}>
        <div className={classes.leftComponent}>
          {onClickViewBill && (
            <TextButton
              className={classes.leftTextButton}
              onClick={onClickViewBill}
              aria-label="View Bill"
            >
              {content.viewBillButton}
            </TextButton>
          )}
          {!!onClickBackArrow && <ArrowBackButton onClick={onClickBackArrow} />}
          {displayLeaveTable && (
            <LeaveTableButton
              displayLeaveTable={displayLeaveTable}
              className={classes.leftTextButton}
            />
          )}
        </div>
        {displayLogo && (
          <div className={classes.centerLogo}>
            <Logo />
          </div>
        )}
        {displayFaq && (
          <div>
            <Link to="/faqs" state={{ previousPage: currentPage }} data-testid="faq-link">
              <IconButton
                data-testid="helpIcon"
                aria-label="FAQ Button"
                className={classes.faqButton}
              >
                <HelpOutline />
              </IconButton>
            </Link>
          </div>
        )}
      </Toolbar>
      {displayMenuNavigation && (
        <div>
          <MainCategoriesBar categories={menuCategories} />
          {selectedSubcategory && <SubCategoriesNavigation />}
        </div>
      )}
    </>
  );
};

export default Header;
